import React from 'react';

import '../../../css/item_index.css';

import strings from '../../../Localization/Localization';

import { withModalHandler } from '../../../HOC/ModalHandler';

import {
  fetchPriceErrorLines,
  processErrorLines
} from '../../../API/PhoneCDRErrors';

import { Container, Form, InputGroup, Navbar, Col, Button } from 'react-bootstrap';

import Loading from '../../Layout/Loading';

import Table from '../../Table/Table';
import TableHeader from '../../Table/TableHeader';
import TableBody from '../../Table/TableBody';
import TableTextHeader from '../../Table/Header/TableTextHeader';
import TableRow from '../../Table/Body/TableRow'

const displayTableHeaders = [
  {
    label: strings.phoneCDR.errorProcessing.price.header.type,
    value: "error_type"
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.inout.label,
    value: item => {
      if(item["error_value_array"]) {
        switch (item["error_value_array"][0]) {
          case "1":
          case 1:
          case true:
            return strings.phoneCDR.errorProcessing.price.header.inout.values.out;
          case "0":
          case 0:
          case false:
            return strings.phoneCDR.errorProcessing.price.header.inout.values.in;
          default:
            return item["error_value_array"][0];
        }
      }
    }
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.roaming.label,
    value: item => {
      if(item["error_value_array"]) {
        switch (item["error_value_array"][1]) {
          case "1":
          case 1:
          case true:
            return strings.phoneCDR.errorProcessing.price.header.roaming.values.y;
          case "0":
          case 0:
          case false:
            return strings.phoneCDR.errorProcessing.price.header.roaming.values.n;
          default:
            return item["error_value_array"][1];
        }
      }
    }
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.date,
    value: item => item["error_value_array"] && item["error_value_array"][2]
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.communicationType.label,
    value: item => {
      if(item["error_value_array"]) {
        switch (item["error_value_array"][3]) {
          case 1:
          case "1":
            return strings.phoneCDR.errorProcessing.price.header.communicationType.values.voice;
          case 2:
          case "2":
            return strings.phoneCDR.errorProcessing.price.header.communicationType.values.data;
          case 3:
          case "3":
            return strings.phoneCDR.errorProcessing.price.header.communicationType.values.sms;
          case 4:
          case "4":
            return strings.phoneCDR.errorProcessing.price.header.communicationType.values.mms;
          case 5:
          case "5":
            return strings.phoneCDR.errorProcessing.price.header.communicationType.values.other;
          default:
            return item["error_value_array"][3];
        }
      }
    }
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.zoneSource,
    value: item => item["error_value_array"] && item["error_value_array"][4]
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.zoneDestination,
    value: item => item["error_value_array"] && item["error_value_array"][5]
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.zoneSourceGroup,
    value: item => item["error_value_array"] && item["error_value_array"][6]
  },
  {
    label: strings.phoneCDR.errorProcessing.price.header.zoneDestinationGroup,
    value: item => item["error_value_array"] && item["error_value_array"][7]
  },
]

/**
 * PriceErrorProcessing
 */
class PriceErrorProcessing extends React.Component {

  constructor(props) {
    super(props);

    this.fetchPriceErrorLines = this.props.modalHandler.addVerificationWithCallback(fetchPriceErrorLines, this.updateErrorLines, this.updateErrorLinesFailure);
    this.processErrorLines = this.props.modalHandler.addVerificationWithCallback(processErrorLines, this.postProcessErrorLines, this.postProcessErrorLinesFailure);

    this.state = {
      loading: true,
      error: false,

      items: null,
      page: null,
      total: null,
      totalPage: null,

      distinct: true,
    }
  }

  componentDidMount() {
    this.fetchPriceErrorLines(this.state.distinct);
  }

  fetch() {
    this.setState({
      loading: true
    }, () => {
      this.fetchPriceErrorLines(this.state.distinct);
    })
  }

  process() {
    this.setState({
      loading: true
    }, () => {
      this.processErrorLines();
    })
  }

  updateErrorLines = (data) => {
    data.items.forEach((item, i) => {
      item["error_value_array"] = item["error_value"].split(';');
    });
    this.setState({
      loading: false,
      items: data.items,
      page: data.page,
      total: data.total,
      totalPage: data.total_page
    })
  }

  updateErrorLinesFailure = (error) => {
    this.setState({
      loading: false,
      error: true
    })
  }

  postProcessErrorLines = (data) => {
    this.setState({
      loading: false
    }, () => this.fetch())
  }

  postProcessErrorLinesFailure = (error) => {
    this.setState({
      loading: false
    })
  }

  displayDistinct() {
    if(!this.state.loading) {
      return (
        <Container className="d-flex flex-column align-items-center">
          <InputGroup className={`container-form-row col-12`}>
            <InputGroup.Prepend
              className="d-flex col container-form-prepend">
              <InputGroup.Text
                id={`form-distinct`}
                className="col-md-12">
                Afficher que les valeurs distincts
              </InputGroup.Text>
            </InputGroup.Prepend>
            <InputGroup.Prepend
              className="d-flex col-auto container-form-prepend container-form-switch">
              <Form.Check
                type="switch"
                id={`form-field-distinct`}
                label=""
                bsCustomPrefix="nk-switch"
                checked={this.state.distinct}
                onChange={(event) => this.setState({
                  distinct: event.target.checked
                }, () => {
                  this.fetch()
                })}
              />
            </InputGroup.Prepend>
          </InputGroup>
        </Container>
      )
    }
  }

  displayQuantity() {
    if(!this.state.loading) {
      return (
        <Container>
          <div style={{color:'#B2B2B2'}}>{strings.formatString(strings.common.itemIndex.totalDisplay, this.state.total)}</div>
        </Container>
      )
    }
  }

  displayList() {
    if(!this.state.loading) {
      return (
        <Container className="d-flex flex-column align-items-center">
          <Table>
            <TableHeader>
              {displayTableHeaders.map((header, i) => {
                return <TableTextHeader key={i} value={header.value} label={header.label}/>
              })}
            </TableHeader>
            <TableBody>
              {this.state.items.map((item, i) => {
                return (
                  <TableRow
                    key={i}
                    data={item}/>
                )
              })}
            </TableBody>
          </Table>
        </Container>
      )
    }
  }

  displayButtons() {
    if(!this.state.loading) {
      return (
        <Navbar fixed="bottom" className="sub-footer">
          <Container>
            <Col xs={12} className="d-flex justify-content-center text-center small-text">
              <Button variant="my-validated" className="btn-sub-footer" onClick={() => this.process()}>{strings.phoneCDR.errorProcessing.price.buttons.startProcess}</Button>
            </Col>
          </Container>
        </Navbar>
      )
    }
  }

  displayLoading() {
    if(this.state.loading) {
      return (
        <Loading/>
      )
    }
  }

  /**
   * Main render method for React Component
   */
  render() {
    return (
      <>
        {this.displayLoading()}
        {this.displayDistinct()}
        {this.displayQuantity()}
        {this.displayList()}
        {this.displayButtons()}
      </>
    );
  }
}

export default withModalHandler(PriceErrorProcessing);
